import { createFileRoute } from "@tanstack/react-router";
import LouisianaTechnologyOffice from "@/pages/LouisianaTechnologyOffice";

export const Route = createFileRoute("/louisiana-technology-office/")({
  component: LouisianaTechnologyOffice,
});
